/**
 * Application configuration settings with support for custom overrides via Stencil blocks.
 */
export const appConfig = Object.assign(
    {
        useDefaultLayout: true,
        useDefaultLayoutFooter: true,
    },
    {
        // Override app-level configuration (e.g., useDefaultLayout, feature flags) below
        // <<Stencil::Block(appConfig)>>
        // <</Stencil::Block>>
    },
);
